import * as React from 'react';
import { Row, Col, Container } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import '../update-payment.scss';
import { ErrorMessage } from '@src/app/_global/components/error-messages/default-error-message';
import { getAdminConfigTableItem } from '@src/app/_global/utility/adminConfigUtils';
interface FailProps {
  message: string;
}

interface ResponseViewProps {
  onExit: () => void;
  updatePaymentData: any;
  adminConfig: any;
  clientConfig: any;
}

const SuccessView: React.SFC<any> = ({updatePaymentData}) => {
  let cfmMessage = 'You have successfully updated your payment method';
  if (updatePaymentData && updatePaymentData.updatePaymentResult && updatePaymentData.updatePaymentResult.payload) {
    if (updatePaymentData.updatePaymentResult.payload.length > 1) {
      cfmMessage += 's.';
    } else {
      cfmMessage += '.';
    }
  }

  let icon = 'fa fa-credit-card fa-2x';
  let cardType = 'Credit Card';
  let cardLastFour = '';
  let cardExpireMonth = '';
  let cardExpireYear = '';
  let isAltPayType = false;
  if (updatePaymentData && updatePaymentData.updatePaymentResult && updatePaymentData.updatePaymentResult.responses) {
    let response = updatePaymentData.updatePaymentResult.responses[0];
    if (response.cardProfiles) {
      cardLastFour = response.cardProfiles[0].creditCardLastFour;
    } else if (response.series && response.series[0].payment) {
      cardLastFour = 
        response.series[0].payment.creditCardNumber.substring(response.series[0].payment.creditCardNumber.length - 4, response.series[0].payment.creditCardNumber.length);
    } else if (response.data) {
      cardLastFour = response.data.payment_instrument.last_four_digits;
    } else if (response.payment) {
      cardLastFour = response.payment.creditCardLastFour;
    }
  }

  if (updatePaymentData && updatePaymentData.updatePaymentResult && updatePaymentData.updatePaymentResult.payload) {
    cardExpireMonth = updatePaymentData.updatePaymentResult.payload[0].creditCardExpireMonth;
    cardExpireYear = updatePaymentData.updatePaymentResult.payload[0].creditCardExpireYear;
    switch (updatePaymentData.updatePaymentResult.payload[0].digitalPaymentType 
            || updatePaymentData.updatePaymentResult.payload[0].creditCardType 
            || updatePaymentData.updatePaymentResult.payload[0].alternatePaymentType) {
      case'VI':
      case'Visa':
        icon = 'fa fa-cc-visa fa-2x';
        cardType = 'Visa';
        break;
      case'MC':
      case'MasterCard':
        icon = 'fa fa-cc-mastercard fa-2x';
        cardType = 'Mastercard';
        break;
      case'DI':
      case'Discover':
        icon = 'fa fa-cc-discover fa-2x';
        cardType = 'Discover';
        break;
      case'AX':
      case'American Express':
        icon = 'fa fa-cc-amex fa-2x';
        cardType = 'American Express';
        break;
      case'DC':
      case'Diners Club':
        icon = 'fa fa-cc-diners-club fa-2x';
        cardType = 'Diners Club';
        break;
      case'PayPal':
        icon = 'fa fa-cc-paypal fa-2x';
        cardType = 'PayPal';
        isAltPayType = true;
        break;
      case'Amazon':
      case'Amazon Pay':
        icon = 'fa fa-amazon fa-2x';
        cardType = 'Amazon Pay';
        isAltPayType = true;
        break;
      case'Apple Pay':
        icon = 'fa fa-apple fa-2x';
        cardType = 'Apple Pay';
        isAltPayType = true;
        break;
      default:
        icon = 'fa fa-credit-card fa-2x';
        cardType = 'Credit Card';
        break;
    }
  }

  let prodNames: any = [];
  if (updatePaymentData && updatePaymentData.updatePaymentResult && updatePaymentData.updatePaymentResult.payload) {
    updatePaymentData.updatePaymentResult.payload.forEach(account => {
      if (account.systemCode === 'CORE') {
        account.entityIds.forEach(entity => {
          if (prodNames.filter(item => item === entity.productName).length === 0) {
            prodNames.push(entity.productName);
          }
        });
      } else {
        if (prodNames.filter(item => item === account.productName).length === 0) {
          prodNames.push(account.productName);
        }
        }
    });
  }

  return (
    <div>
      <Row className="d-flex align-items-right">
        <Col xs={12} sm={12} md={12}>
        <div className="update-payment-print">
            <button
              tabIndex={0}
              className="print-page icon-blue pointer fa fa-2x fa-print print-btn no-print"
              title="Print this page."
              onClick={() =>  window.print()}
            />
          </div>
        </Col>
      </Row>
      <Row className="mb-2">
        <Col xs={12} sm={12} md={12}>
          <h4>
            <FormattedMessage
              id={'address.congratulations'}
              description={'congratulation message'}
              defaultMessage={cfmMessage}
            />
          </h4>
       </Col>
      </Row>
      <Row className="mb-2">
        <Col xs={12} sm={12} md={12}>
          <i className={icon}></i> 
          <span className="ml-2 pb-2"> 
            {cardType} {!isAltPayType ? `ending in ${cardLastFour} expires ${cardExpireMonth}/${cardExpireYear}` : ''}
            </span>
        </Col>
      </Row>

      {updatePaymentData 
        && updatePaymentData.updatePaymentResult
        && prodNames.map((pmt) => {
          return (
            <Container key={`${pmt}-pmt`}  fluid={true}>
              <Row key={`${pmt}-products`}>
                <Col xs={12} sm={12} md={12} key={`${pmt}`} className="ml-5 pl-4">
                  {pmt}
                </Col>
              </Row>
            </Container>
          );
        }
      )}
      <div className="subs-response-element">
        <FormattedMessage
          id={'email.emailupdatesuccess'}
          description={'Email update message'}
          defaultMessage={'You may print this confirmation screen for your records.'}
        />
      </div>
    </div>
  );
};

export const ResponseView: React.SFC<ResponseViewProps> = props => {
  const { updatePaymentData, onExit, adminConfig, clientConfig } = props;
  let pageIntroTable = getAdminConfigTableItem(
    adminConfig,
    clientConfig,
    'PageIntro',
  );
  let pageIntro;
  if (pageIntroTable.PageIntroductions) {
    pageIntro = pageIntroTable.PageIntroductions.find(intro => {
      return intro.route === 'updatepayment';
    });
  }
  let pageIntroDescHtml = document.getElementsByClassName('page-intro-desc') || null;
  if (pageIntroDescHtml && pageIntroDescHtml.length > 0) {
    pageIntroDescHtml[0].innerHTML = pageIntro ? (pageIntro.confDescription ? pageIntro.confDescription : pageIntro.description ) : '';
  }
  let pageIntroLabelHtml = document.getElementsByClassName('page-intro-label') || null;
  if (pageIntroLabelHtml && pageIntroLabelHtml.length > 0) {
    pageIntroLabelHtml[0].innerHTML = pageIntro ? pageIntro.label + ' Confirmation' : '';
  }

  return (
    <div className="email-response-view">
      <Row>
        <Col xs={12} sm={12} md={12}>
          <div className="small-text mb-2" />
          <div className="mb-4">
            {updatePaymentData && updatePaymentData.updatePaymentResult.success && <SuccessView updatePaymentData={updatePaymentData}/>}
            {updatePaymentData && !updatePaymentData.updatePaymentResult.success && <ErrorMessage onReset={onExit} />}
          </div>
        </Col>
      </Row>
      <Row className="mt-auto">
        <Col xs={12} sm={12} md={12}>
          <div className="d-flex justify-content-end">
            <button
              className="btn btn-secondary"
              type="button"
              onClick={onExit}
            >
              <FormattedMessage
                id={'app.cancel'}
                description={'close button text'}
                defaultMessage={'Close'}
              />
            </button>
          </div>
        </Col>
      </Row>
    </div>
  );
};
